import { Tooltip } from 'antd';
import { CSSProperties, ReactNode } from 'react';

import { Tag } from '../antd/Tag';

type ExemptTagProps = {
  tooltip: ReactNode;
  style?: CSSProperties;
};

export function ExemptTag(props: ExemptTagProps) {
  const { tooltip, style } = props;

  return (
    <Tooltip title={tooltip}>
      <Tag className="exempt rounded" style={style}>
        Isenta
      </Tag>
    </Tooltip>
  );
}
